import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ContentPage from './pages/ContentPage';
import AnnouncementView from './pages/AnnouncementView';
import AnnouncementsList from './pages/AnnouncementsList';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './css/styles.css';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Header />
        <main className="body-content">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<ContentPage />} />
            <Route path="/timetables" element={<ContentPage />} />
            <Route path="/results" element={<ContentPage />} />
            <Route path="/circulars" element={<ContentPage />} />
            <Route path="/grievanances" element={<ContentPage />} />
            <Route path="/contact" element={<ContentPage />} />
            <Route path="/ourstaff" element={<ContentPage />} />
            <Route path="/announcements" element={<AnnouncementsList />} />
            <Route path="/announcement/:id" element={<AnnouncementView />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
